import { Button } from "@material-ui/core";
import { X } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import useStyles from "./ProjectMediaListView.style";

const ProjectMediaViewModal = ({ url, handleClose, fileType }) => {
  const classes = useStyles();
  const [textContent, setTextContent] = useState("");

  useEffect(() => {
    if (fileType === "text" || fileType === "json") {
      fetch(url)
        .then((res) => res.text())
        .then((data) => {
          if (fileType === "json") {
            try {
              setTextContent(JSON.stringify(JSON.parse(data), null, 2));
            } catch (e) {
              setTextContent("Invalid JSON format");
            }
          } else {
            setTextContent(data);
          }
        })
        .catch(() => setTextContent("Failed to load content"));
    }
  }, [url, fileType]);

  const highlightJson = (jsonString) => {
    if (!jsonString) return "";

    return jsonString
      .replace(/([{}\[\]])/g, '<span style="color: orange;">$1</span>') // Braces/brackets
      .replace(
        /"([^"]+)"(?=\s*:)/g,
        '<span style="color: hotpink;">"$1"</span>'
      ) // Keys
      .replace(/: "([^"]*)"/g, ': <span style="color: lightgreen;">"$1"</span>') // String values
      .replace(
        /: (\d+|true|false|null)/g,
        ': <span style="color: lightgreen;">$1</span>'
      ); // Numbers/booleans/null
  };

  return (
    <div className={classes.modalRoot}>
      <div className={classes.modalContainer}>
        <div className={classes.buttonContainer}>
          <Button onClick={handleClose} className={classes.closeIcon}>
            <X />
          </Button>
        </div>

        {fileType === "image" ? (
          <img src={url} alt="" className={classes.imageView} />
        ) : fileType === "video" ? (
          <video src={url} controls className={classes.videoPlayer} />
        ) : fileType === "pdf" ? (
          <div className={classes.flexCenterModal}>
            <Document file={url}>
              <Page pageNumber={1} />
            </Document>
          </div>
        ) : fileType === "json" ? (
          <div className={classes.textPreviewBox}>
            <pre
              className={classes.textPreview}
              dangerouslySetInnerHTML={{ __html: highlightJson(textContent) }}
            />
          </div>
        ) : fileType === "text" ? (
          <div className={classes.textPreviewBox}>
            <pre className={classes.textPreview}>{textContent}</pre>
          </div>
        ) : (
          <div className={classes.canNotPreviewContainer}>
            <span className={classes.canNotPreviewText}>
              Can't Preview this file
            </span>
            <span className={classes.downloadText}>
              Download this file to preview
            </span>
          </div>
        )}

        <div className={classes.flexCenterModal}>
          <Button
            onClick={() => window.open(url)}
            className={classes.downloadButton}
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProjectMediaViewModal;
